import { CircleNode, CircleNodeModel, h } from '@logicflow/core';
import { getEventIconElements } from './eventIcons';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class EndEventView extends CircleNode {
  getShape() {
    const { model } = this.props;
    const { x, y, r, properties } = model;
    const style = model.getNodeStyle();
    const trigger = properties.trigger || '';

    return h('g', {}, [
      h('circle', { cx: x, cy: y, r, ...style }),
      ...getEventIconElements(h, x, y, trigger, true, style.stroke, 1.0),
    ]);
  }
}

class EndEventModel extends CircleNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.r = 18;
    initLabelOffset(this, data, this.r + 14);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'endEvent');
    style.stroke = t.stroke || '#f5222d';
    style.strokeWidth = t.strokeWidth ?? 3;
    style.fill = t.fill || '#fff1f0';
    return style;
  }
}

export const EndEvent = {
  type: 'epx:EndEvent',
  view: EndEventView,
  model: EndEventModel,
};
